export const toDateMillis = value => {
    if (value === null || value === undefined || value === "") return null;
    if (typeof value === "number") return value;
    if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value.getTime();
    if (typeof value?.toMillis === "function") return value.toMillis();
    if (typeof value?._seconds === "number") return value._seconds * 1000;
    if (typeof value?.seconds === "number") return value.seconds * 1000;

    const parsed = Date.parse(value);
    return Number.isFinite(parsed) ? parsed : null;
};

export const formatDateZA = value => {
    const millis = toDateMillis(value);
    return millis ? new Date(millis).toLocaleDateString("en-ZA") : "Not available";
};

export const formatTimeZA = value => {
    const millis = toDateMillis(value);
    return millis ? new Date(millis).toLocaleTimeString("en-ZA") : "Not available";
};

export const formatDateTimeZA = value => {
    const millis = toDateMillis(value);
    return millis ? new Date(millis).toLocaleString("en-ZA") : "Not available";
};
